import { AxisConfig } from "@tether-web-portal/components/charts/types";
import { HeatMapColumn, HeatMapXScale } from "@tether-web-portal/components/heat-map/v2/HeatMap";
import { Group } from "@visx/group";
import { CSSProperties } from "react";

export const ColumnLabels = ({
  columns,
  xScale,
  axisHeightConfig,
  labelStyle,
}: {
  columns: HeatMapColumn[];
  xScale: HeatMapXScale;
  axisHeightConfig: AxisConfig;
  labelStyle: CSSProperties;
}) => {
  return (
    <Group data-name={"heat-map-column-labels"}>
      {columns.map(({ label, key }) => (
        <Group key={key} left={xScale(key)}>
          <Group top={axisHeightConfig.outerMargin}>
            <foreignObject x={0} y={0} height={axisHeightConfig.label} width={xScale.bandwidth()}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  alignContent: "end",
                  textAlign: "center",
                  ...labelStyle,
                }}
              >
                {label}
              </div>
            </foreignObject>
          </Group>
        </Group>
      ))}
    </Group>
  );
};
